/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line class-methods-use-this

import React from 'react';
import { tpShowModalEmitter } from 'modules/WithTimesPointModal/TimesPointModalUtils';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { bindGa } from 'helpers/analytics';
import s from './TimesPointWidget.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class TimesPointWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      showInGeo: true,
    };
    this.openSidebar = this.openSidebar.bind(this);
  }

  componentDidMount() {
    // this.setTimesPointShare();
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      window.geoinfo.CountryCode !== 'IN'
    ) {
      this.setState({ showInGeo: false });
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.msid !== prevProps.msid) {
  //     this.setTimesPointShare();
  //   }
  // }

  // @bindGa({})
  // openEmailPopup() {
  //   this.setState({ openEmailPopUp: true });
  // }

  // @bindGa({})
  // handleEmailClick() {
  //   const { url, title, disableShortUrl } = this.props;
  //   let { utm } = this.props;
  //   utm = this.getUtmDetail(utm, 'email');
  //   const titleToBeshared = title || toiTitle;
  //   const urlToBeShared = `${getShortUrl(
  //     `${url}${utm}`,
  //     'email',
  //     true,
  //     disableShortUrl,
  //   )}
  //     \n\nUse the TOI app to get Breaking news and headlines. Download now: \nhttps://timesofindia.onelink.me/efRt/ASmwebshare`;
  //   const body = `body=${encodeURIComponent(urlToBeShared)}`;
  //   const intentUrl = `mailto:?subject=TOI: ${titleToBeshared}`;
  //   window.location.href = `${intentUrl}&${body}`;
  // }

  // closeEmailPopup = () => {
  //   this.setState({ openEmailPopUp: false });
  //   if (typeof this.props.socialWidgetToggle === 'function') {
  //     this.props.socialWidgetToggle();
  //   }
  // };

  setTimesPointShare() {
    if (
      typeof window.TPWidget !== 'undefined' &&
      typeof window.TPWidget.init === 'function' &&
      this.divId
    ) {
      setTimeout(() => {
        window.TPWidget.init({
          widgets: [
            {
              ele: this.divId,
              widgetType: 'tpwidget-two',
              callback() {
                tpShowModalEmitter('tpwidget-two');
              },
            },
          ],
        });
      }, 0);
    }
  }
  commentsRedirectHandling = () => {
    if (this.props.forceOpenSidebar) {
      this.props.openSidebar(this.props.msid);
    } else {
      const url = this.props.printLayout
        ? `https://m.timesofindia.com/print_articleshow_comments/${
            this.props.msid
          }.cms`
        : `https://m.timesofindia.com/articleshow_comments/${
            this.props.msid
          }.cms`;
      window.location = url;
    }
  };

  @bindGa({})
  // eslint-disable-next-line no-unused-vars
  gaClickHandler(e) {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'times_point',
      category: this.props.isLiveBlog
        ? 'liveblog_sticky'
        : 'articleshow_sticky',
    });
  }

  @bindGa({})
  openSidebar() {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'comments',
      category: this.props.isLiveBlog
        ? 'liveblog_sticky'
        : 'articleshow_sticky',
    });
    if (this.props.isWapView) {
      this.commentsRedirectHandling();
    } else {
      if (!(this.props.isTablet && this.props.isTablet())) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }
      this.props.openSidebar(this.props.msid);
    }
  }

  getDivId = () => {
    let divId = this.props.isParent
      ? 'widget-two'
      : `tpwidget-${this.props.msid}${
          this.props.type ? `-${this.props.type}` : ''
        }`;
    if (this.props.sticky) {
      divId = 'widget-tp-sticky';
    } else if (this.props.type && this.props.isParent) {
      divId = `widget-two-${this.props.type}`;
    }
    if (this.props.isPerpetual) {
      divId += `-${this.props.articleIndex}`;
    }
    this.divId = divId;

    return divId;
  };

  getUtmDetail = (utm, channel) => {
    if (typeof utm !== 'string') return '';
    if (utm.indexOf('####') > -1) {
      return utm.replace('####', channel);
    }
    return utm;
  };

  render() {
    const divId = this.getDivId();
    const { gaCategory, gaAction = '', gaIndex = '' } = this.props;
    // const { gaAction = '' } = this.props;
    // const { gaIndex = ''} = this.props;
    // const { gaLabel = '' } = this.props;
    const webcss = this.props.styles || {};
    const {
      textRequired,
      tpShow,
      showComment,
      commentsCount,
      topsticky,
      wrapperClass,
      tpCssOverride,
      showWhatsappNativeShareTP,
    } = this.props;
    const { isWapView } = this.props;

    return (
      <>
        <div
          className={`${s.social_sharing} ${webcss.social_sharing} ${
            textRequired ? webcss.socialSharingWithText : ''
          } ${topsticky ? webcss.topsticky : ''} ${wrapperClass || ''} ${this
            .props.isSmallicon && s.smallsocialicons}`}
        >
          {/* {tpShow && <span className={`${webcss.timespoint}`}>99 Points</span>} */}
          {/* {tpShow &&
            !isWapView &&
            this.state.showInGeo && (
              <span
                data-tpwidget="widget-two"
                id={divId}
                className={`${s.tp_icon} ${webcss.timespoint} ${tpCssOverride}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'times_point'}|${gaIndex}times_point`}
                onClick={e => this.gaClickHandler(e)}
              />
            )} */}

          {tpShow && isWapView && this.state.showInGeo}
          {/* {tpShow &&
            isWapView &&
            this.state.showInGeo && (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                href="/timespoints"
                data-tpwidget="widget-two"
                id={divId}
                className={`${s.tp_icon} ${webcss.timespoint} ${tpCssOverride}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'times_point'}|${gaIndex}times_point`}
                onClick={e => this.gaClickHandler(e)}
              />
            )} */}

          {this.props.isWapView && this.props.sticky && this.props.children}
          {showComment &&
            isWapView &&
            commentsCount > 0 && (
              <Link
                className={s.comment}
                href="javascript: void(0)"
                // to={`https://m.timesofindia.com/articleshow_comments/${
                //   this.props.msid
                // }.cms`}
                onClick={this.openSidebar}
                data-ga={`${gaCategory}|${gaAction ||
                  'comments'}|${gaIndex}comments`}
              >
                <span>{commentsCount}</span>
              </Link>
            )}
          {showComment &&
            !isWapView &&
            commentsCount > 0 && (
              <Link
                href="javascript: void(0)"
                className={s.comment}
                data-ga={`${gaCategory}|${gaAction ||
                  'comments'}|${gaIndex}comments`}
                onClick={this.openSidebar}
              >
                <span>{commentsCount}</span>
              </Link>
            )}
          {!(
            this.props.isWapView &&
            this.props.sticky &&
            !showWhatsappNativeShareTP
          ) && this.props.children}
        </div>
      </>
    );
  }
}

TimesPointWidget.propTypes = {
  styleObj: PropTypes.shape({}).isRequired,
  //url: PropTypes.string.isRequired,
  //title: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
  openSidebar: PropTypes.func.isRequired,
  msid: PropTypes.string.isRequired,
  //via: PropTypes.string.isRequired,
  //wu: PropTypes.string.isRequired,
  isTablet: PropTypes.func.isRequired,
  isWapView: PropTypes.bool,
  textRequired: PropTypes.bool,
  tpShow: PropTypes.bool,
  //whatsAppShow: PropTypes.bool,
  //linkeDin: PropTypes.bool,
  topsticky: PropTypes.bool,
  styles: PropTypes.shape({}),
  isParent: PropTypes.bool,
  commentsCount: PropTypes.number,
  showComment: PropTypes.bool,
  wrapperClass: PropTypes.string,
  children: PropTypes.node,
  gaCategory: PropTypes.string,
  sticky: PropTypes.bool,
  type: PropTypes.string,
  forceOpenSidebar: PropTypes.bool,
  //socialWidgetToggle: PropTypes.func,
  // gaLabel: PropTypes.string,
  gaAction: PropTypes.string,
  //liveblogMailHeading: PropTypes.string,
  showWhatsappNativeShareTP: PropTypes.bool,
  //hideemail: PropTypes.bool,
  //whatsAppCssOverride: PropTypes.string,
  tpCssOverride: PropTypes.string,
  //defaultEmailView: PropTypes.bool,
  //utm: PropTypes.string,
  //disableShortUrl: PropTypes.bool,
  gaIndex: PropTypes.string,
  //hideSharingButtons: PropTypes.bool,
  //showFollowButtons: PropTypes.bool,
  printLayout: PropTypes.bool,
  isLiveBlog: PropTypes.bool,
};

TimesPointWidget.defaultProps = {
  isWapView: false,
  textRequired: false,
  tpShow: false,
  //whatsAppShow: false,
  // linkeDin: false,
  topsticky: false,
  styles: {},
  isParent: false,
  commentsCount: null,
  showComment: false,
  wrapperClass: '',
  children: null,
  gaCategory: 'share',
  sticky: false,
  type: '',
  forceOpenSidebar: false,
  // socialWidgetToggle: undefined,
  // gaLabel: '',
  // liveblogMailHeading: undefined,
  showWhatsappNativeShareTP: false,
  // whatsAppCssOverride: '',
  tpCssOverride: '',
  // defaultEmailView: false,
  // utm: '',
  // disableShortUrl: false,
  gaAction: '',
  gaIndex: '',
  // hideemail: false,
  // hideSharingButtons: false,
  // showFollowButtons: false,
  printLayout: false,
  isLiveBlog: false,
};

export default TimesPointWidget;
